import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    rewardsPreviewTileButton: 'b b-grey-60 px-4 py-2 c-grey-30'
  }
} satisfies RecursivePartial<VfConfig['loyalty']>
